exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_object-gops.js
// module id = 61
// module chunks = 1